import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import {
  githubAuthApiRef,
  type SignInPageProps,
} from '@backstage/core-plugin-api';
import { SignInPage } from '@backstage/core-components';

const githubSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => (props: SignInPageProps) => (
      <SignInPage
        {...props}
        provider={{
          id: 'github-auth-provider',
          title: 'GitHub',
          message: 'GitHub アカウントでサインイン',
          apiRef: githubAuthApiRef,
        }}
      />
    ),
  },
});

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [githubSignInPage],
});
